import { Injectable } from '@angular/core';
import { environment } from '../environments/environment'
// import { io } from 'socket.io-client';
import { BehaviorSubject, Subject } from 'rxjs';
const io = require('socket.io-client');
declare var require: any

@Injectable()
export class SocketioService {
  socket: any;

  // Observable string sources
  private componentMethodCallSource = new Subject<any>();

  // Observable string streams
  caller = this.componentMethodCallSource.asObservable();

  constructor() {
  }

  setupSocketConnection() {
    this.socket = io(environment.SOCKET_ENDPOINT);
    this.socket.emit('my message', 'Hello there from Angular.');
    this.socket.on('my broadcast', (data: string) => {
      console.log(data);
    });

    this.socket.on("noti", (data: object) => {
      this.componentMethodCallSource.next(data)
    });
  }

  subscribe(newKey: string, oldKey: string){
    if(oldKey){
      this.socket.removeListener(oldKey);
    }

    this.socket.on(sessionStorage.getItem(newKey), (data: object) => {
      this.componentMethodCallSource.next(data)
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/socketio.service.ts